import script from "./PermissionWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionWrapper.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__